import { Component, EventEmitter, Inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';

export interface ProgressData {
  message: string;
  steps: number;
  progress: EventEmitter<string>;
}

@AutoUnsubscribe()
@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  standalone: true,
  imports: [MatProgressBarModule, TranslatePipe],
})
export class ProgressComponent {
  progress = 0;
  steps: number;
  subscription: Subscription;
  message: string;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public readonly data: ProgressData,
    private readonly snackRef: MatSnackBarRef<ProgressComponent>,
  ) {
    this.steps = data.steps;
    this.message = data.message;
    this.subscription = data.progress.subscribe((message) => {
      this.message = message;
      this.progress = this.progress + 1;
      if (this.progress === this.steps) {
        setTimeout(() => {
          snackRef.dismiss();
        }, 3000);
      }
    });
  }
}
